<div
  id="{{ toastId }}"
  class="toast toast-{{ toastConfig.type }} mt-2"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="toast-header bg-{{ toastConfig.type }} text-light">
    <strong class="me-auto">{{ toastConfig.title }}</strong>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>
  <div class="toast-body">
    {{ toastConfig.body }}
    @if (toastConfig.items && !!toastConfig.items.length) {
      <ul>
        @for (item of toastConfig.items; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    }
  </div>
</div>
